import { Footer } from "../../ui/footer/Footer";
import { Header } from "../../ui/header/Header";
import { Content } from "./Content";
import { Options } from "./Options";

export const About = () => {
  return (
    <div className="home-wrapper">
      <Header />
      <Content />
      <div className="footer-background">
        <img
          src={`${process.env.PUBLIC_URL}/assets/imagenes/home/fondo_puntitos.png`}
          className="background-dots"
          alt="background"
        />
        <Options />
        <Footer />
      </div>
    </div>
  );
};
